// extracted by mini-css-extract-plugin
module.exports = {"container":"i_BV","controller":"i_BW","label-container":"i_BX","explainer":"i_BY"};